// src/components/LoginAnnouncementModal.js
import React, { useEffect, useState } from 'react';
import { getActiveLoginPopup } from '../services/api';
import './LoginAnnouncementModal.css';

const API_BASE = process.env.REACT_APP_API_URL || '/api';
const SHOW_FLAG = 'wadphol_show_login_popup';
const HIDE_UNTIL_KEY = 'wadphol_login_popup_hide_until';

function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

function isHiddenForToday(version) {
  try {
    const raw = localStorage.getItem(HIDE_UNTIL_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return parsed.date === todayKey() && parsed.version === String(version);
  } catch {
    return false;
  }
}

export default function LoginAnnouncementModal() {
  const [popup, setPopup] = useState(null);
  const [visible, setVisible] = useState(false);
  const [hideToday, setHideToday] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const shouldShow = sessionStorage.getItem(SHOW_FLAG) === '1';
    if (!shouldShow) return;

    setLoading(true);
    getActiveLoginPopup()
      .then(res => {
        const data = res.data?.data;
        if (!data?.enabled || !data?.image) return;
        if (isHiddenForToday(data.version)) {
          sessionStorage.removeItem(SHOW_FLAG);
          return;
        }
        setPopup(data);
        setVisible(true);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleClose = () => {
    if (hideToday && popup?.version) {
      localStorage.setItem(HIDE_UNTIL_KEY, JSON.stringify({
        date: todayKey(),
        version: String(popup.version),
      }));
    }
    sessionStorage.removeItem(SHOW_FLAG);
    setVisible(false);
  };

  if (loading || !visible || !popup) return null;

  const imageUrl = `${API_BASE}/school/login_popup_image.php?t=${encodeURIComponent(popup.version || Date.now())}`;

  return (
    <div className="login-popup-overlay" onClick={e => e.target === e.currentTarget && handleClose()}>
      <div className="login-popup-modal" role="dialog" aria-modal="true" aria-label="ประกาศ">
        <button type="button" className="login-popup-close" onClick={handleClose} aria-label="ปิด">
          ✕
        </button>
        <div className="login-popup-body">
          <img src={imageUrl} alt="ประกาศ" />
        </div>
        <div className="login-popup-footer">
          <label className="login-popup-hide-today">
            <input
              type="checkbox"
              checked={hideToday}
              onChange={e => setHideToday(e.target.checked)}
            />
            <span>ไม่แสดงอีกในวันนี้</span>
          </label>
          <button type="button" className="btn btn-primary" onClick={handleClose}>
            รับทราบ
          </button>
        </div>
      </div>
    </div>
  );
}
